import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import GBColorPropType from '../../prop-types/GBColor';
import styles from './panel.css';
var cx = classnames.bind(styles);
export default function Panel(_ref) {
  var bordered = _ref.bordered,
      className = _ref.className,
      color = _ref.color,
      inline = _ref.inline,
      large = _ref.large,
      padded = _ref.padded,
      raised = _ref.raised,
      rounded = _ref.rounded,
      translucent = _ref.translucent,
      rest = _objectWithoutProperties(_ref, ["bordered", "className", "color", "inline", "large", "padded", "raised", "rounded", "translucent"]);

  return React.createElement("div", _extends({
    className: cx('panel', color, {
      translucent: translucent,
      raisedLg: raised && raised === 'lg',
      raisedSm: raised && raised !== 'lg',
      bordered: bordered,
      padded: padded,
      rounded: rounded,
      inline: inline,
      large: large
    }, className)
  }, rest));
}
Panel.propTypes = {
  /** Boolean indicating if a border should be used */
  bordered: PropTypes.bool,

  /** Class name to apply to component */
  className: PropTypes.string,

  /** Button color */
  color: GBColorPropType,

  /** Boolean indicating if it should adapt width to content */
  inline: PropTypes.bool,

  /** Boolean to indicate if the panel should have more padding */
  large: PropTypes.bool,

  /** Boolean indicating if there should be padding inside */
  padded: PropTypes.bool,

  /** Boolean to indicate if the panel should have a box shadow */
  raised: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['lg'])]),

  /** Boolean indicating if there should be a border radius */
  rounded: PropTypes.bool,

  /** Boolean to indicate if the panel should have a slightly transparent background */
  translucent: PropTypes.bool
};
Panel.defaultProps = {
  bordered: false,
  className: undefined,
  color: 'grey',
  inline: false,
  large: false,
  padded: true,
  raised: false,
  rounded: true,
  translucent: false
};